import React, { useState } from "react";
import ItemsContainer from "./ItemsContainer";
import SocialIcons from "./SocialIcons";
import { Icons } from "./Menus";

const Footer = () => {
  const MAILCHIMP_URL = "78e03f8cec75897cab5dddcce3fa0109-us21";

  //State to handle handle submission
  const [submissionResult, setSubmissionResult] = useState("");

  //State to handle incorrect email address
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  //If email address is not in the correct format
  const handleEmailChange = (event) => {
    const value = event.target.value;
    setEmail(value);
    if (!value.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/)) {
      setEmailError("Invalid email format");
    } else {
      setEmailError("");
    }
  };

  //handleSubmit Function
  const handleSubmit = async (event) => {
    event.preventDefault(); // prevent default form submission behavior
    if (emailError) {
      return;
    }
    try {
      const response = await fetch(MAILCHIMP_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      if (response.ok) {
        setSubmissionResult("Email successfully subscribed!");
      } else {
        setSubmissionResult(data.title || "Unknown error occurred.");
      }
    } catch (error) {
      setSubmissionResult("Network error occurred.");
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="md:flex md:justify-between md:items-center sm:px-12 px-4 bg-gradient-to-br from-green-500 to-indigo-600 py-7">
        <h1
          className="lg:text-3xl text-2xl md:mb-0 mb-6 lg:leading-normal font-semibold
         md:w-2/5"
        >
          <span className="text-white-400 hover:bg-teal-500">
            RECEIVE CONFERENCE NOTIFICATIONS
          </span>
        </h1>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Enter Your Email Address"
            className="text-gray-800
           sm:w-72 w-full sm:mr-5 mr-1 lg:mb-0 mb-4 py-2.5 rounded px-2 focus:outline-none"
            value={email}
            onChange={handleEmailChange}
          />
          <button
            type="submit"
            className="transition ease-in-out bg-teal-400 -translate-y-1 hover:scale-110 hover:bg-teal-500 duration-300 px-5 py-2.5 font-[Poppins]
           rounded-md text-white md:w-auto w-full"
          >
            Send
          </button>
        </form>
      </div>
      {emailError && <span className="text-red-500 text-sm">{emailError}</span>}
      {submissionResult && (
        <span className="text-green-500 text-sm">{submissionResult}</span>
      )}
      <ItemsContainer />
      <div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10
      text-center pt-2 text-white-400 text-sm pb-8"
      >
        <span>
          &copy; {new Date().getFullYear()} KIPPRA. All rights reserved.
        </span>
        <span>Terms · Privacy Policy</span>
        <SocialIcons Icons={Icons} />
      </div>
    </footer>
  );
};

export default Footer;
